export class NavigationHelper {

  static getQueryParam(paramName: string) {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam: string = urlParams.get(paramName);
    return myParam;
  }

  static getRefreshKey() {
    return new Date().getTime().toString();
  }

  static showMobileSidebar() {
    const sidebar = document.querySelector(".section-sidebar");
    const overlay = document.querySelector(".sidebar-overlay");

    if (sidebar) {
      sidebar.classList.add("show");
    }
    if (overlay) {
      overlay.classList.add("show");
    }
  }

  static hideMobileSidebar() {
    const sidebar = document.querySelector(".section-sidebar");
    const overlay = document.querySelector(".sidebar-overlay");

    if (sidebar) {
      sidebar.classList.remove("show");
    }
    if (overlay) {
      overlay.classList.remove("show");
    }
  }

  static toggleMobileSidebar() {
    const sidebar = document.querySelector(".section-sidebar");
    const overlay = document.querySelector(".sidebar-overlay");

    if (sidebar) {
      sidebar.classList.toggle("show");
    }
    if (overlay) {
      overlay.classList.toggle("show");
    }
  }

  static closeMobileSidebar() {
    const sidebar = document.querySelector(".section-sidebar");
    const overlay = document.querySelector(".sidebar-overlay");

    if (sidebar) {
      sidebar.classList.remove("show");
    }
    if (overlay) {
      overlay.classList.remove("show");
    }
  }


}

